module.exports = __webpack_public_path__ + "img/raditubelogo.bdfcbb19.svg";